export default __webpack_public_path__ + "static/your-blueprint-logo-2eab70c648fc274e351ad2e6e202f07e.png";